var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute top-0 bottom-0 left-0 right-0 flex flex-row justify-center"},[_c('div',{staticClass:"spinner text-3xl"})])}]

export { render, staticRenderFns }